const MENU_LIST_NUMBERS_COUNT_URI = "/ajax/getItemCounts";
const GET_SIDE_MENU_URI = "/webservice/getSideMenu";

module.exports = {
    getItemNumbersCount: function (data) {
        return axios.get(MENU_LIST_NUMBERS_COUNT_URI,{params:data});
    },
    getSideMenu: function () {
        return axios.get(GET_SIDE_MENU_URI);
    },
}
